export default "__VITE_ASSET__BjzPVikh__"